exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close {\n  font-size: 25px !important;\n  color: red !important; }\n\n.actionTitle {\n  font-size: 12px;\n  font-weight: bold;\n  color: #717D92; }\n\n.reportStatus {\n  font-size: 12px;\n  font-weight: bold;\n  color: #717D92; }\n\n.reportTitle {\n  font-size: 14px;\n  font-weight: bold; }\n\n.reportRemarks {\n  font-size: 16px;\n  font-weight: bold; }\n\n.statusBadge {\n  padding: 8px 10px !important;\n  font-size: 11px !important; }\n\n.actionTitle {\n  font-size: 13px;\n  font-weight: bold; }\n\n.historyLabel {\n  font-size: 11px;\n  font-weight: bold;\n  color: #717D92; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/corrective-action-almaha-history-modal/corrective-action-almaha-history-modal.component.scss
// module id = ../../../../../src/app/corrective-action-almaha-history-modal/corrective-action-almaha-history-modal.component.scss
// module chunks = main